import $ from 'jquery';
import { formatDatesToLocalTime } from '../Common/Formatting';

let delayTimer,
    searchForm,
    searchFormUrl;

AddSearchInputEvent();

function AddSearchInputEvent() {
    const el = $('input[type="search"]');
    el.on('input',
        function () {
            searchForm = $(this).closest('form');
            searchFormUrl = searchForm.attr('action');
            updateSearchResults();
        });

    const val = el.val();
    el.val('');
    el.val(val);
    el.focus();
}

function updateSearchResults() {
    clearTimeout(delayTimer);
    delayTimer = setTimeout(function () {
        $('.results-table').html('<div class="loader"></div>');

        $.ajax({
            type: 'GET',
            url: searchFormUrl,
            data: searchForm.serialize(),
            success(page) {
                const searchResult = $(page).find('.results-table').html();
                const footerDetails = $(page).find('.table-footer-actions').html();
                const resetButton = $(page).find('.reset-button').html();

                $('.results-table').html(searchResult);
                $('.table-footer-actions').html(footerDetails);
                $('.reset-button').html(resetButton);

                const actionMenu = $(page).find('.action-menu').html();
                $('.action-menu').html(actionMenu);

                const dateElements = $('.results-wrapper').find('[data-to-local-time-date-utc]');
                formatDatesToLocalTime(dateElements);
            }
        });
    }, 800);
}
